import { FormattedMessage } from 'react-intl';
import { LoadingButton, type LoadingButtonProps } from '@mui/lab';

export type CancelButtonProps = LoadingButtonProps & {
  labelId?: string;
};

const CancelButton = ({labelId = 'button.cancel', ...props} : CancelButtonProps) : JSX.Element => {
  return (
    <LoadingButton variant='contained' {...props}>
      <FormattedMessage id={labelId} />
    </LoadingButton>
  );
};

export default CancelButton;